{
  "customers.title": "客户",
  "customers.description": "集中查找和维护客户资料，并进入客户 360 查看可访问的服务上下文。",
  "customers.directory": "客户目录",
  "customers.new": "新建客户",
  "customers.refresh": "刷新",
  "customers.refreshingList": "正在刷新客户列表",
  "customers.clearSearch": "清除搜索",
  "customers.clearFilters": "清除筛选",
  "customers.searchLabel": "搜索客户",
  "customers.searchPlaceholder": "搜索姓名、电话、邮箱或业务标识…",
  "customers.loadingList": "正在加载客户列表…",
  "customers.empty.filteredTitle": "没有匹配的客户",
  "customers.empty.filteredDetail": "换个关键词，或清除当前搜索条件。",
  "customers.empty.title": "还没有客户",
  "customers.empty.detail": "创建第一位客户后，就可以统一维护资料与服务记录。",
  "customers.paginationLabel": "位客户",
  "customers.unnamed": "未命名客户",
  "customers.noAdditionalInfo": "暂无补充资料",
  "customers.notRecorded": "未记录",
  "customers.notBound": "未绑定",
  "customers.actions": "操作",
  "customers.customerActions": "{name} 操作",
  "customers.view360": "查看客户 360",
  "customers.editContact": "编辑联系资料",
  "customers.emptyTable": "暂无客户",
  "customers.table.customer": "客户",
  "customers.table.contact": "联系方式",
  "customers.table.businessBinding": "业务绑定",
  "customers.table.updatedAt": "最近更新",
  "customers.table.profileUpdated": "资料已更新",
  "customers.table.created": "客户已创建",
  "customers.sort.createdAt": "创建时间",
  "customers.sort.updatedAt": "最近更新",
  "customers.sort.name": "客户名称",
  "customers.sort.phone": "手机号",
  "customers.sort.email": "邮箱",
  "customers.form.editTitle": "编辑客户",
  "customers.form.createTitle": "新建客户",
  "customers.form.editDescription": "更新客户的基础联系资料；可信业务标识不在这里修改。",
  "customers.form.createDescription": "录入客户的基础资料，姓名、电话和邮箱至少填写一项。",
  "customers.form.emptyTitle": "客户资料不能为空",
  "customers.form.name": "姓名",
  "customers.form.phone": "电话",
  "customers.form.email": "邮箱",
  "customers.form.namePlaceholder": "例如 张三",
  "customers.form.phonePlaceholder": "例如 +86 138 0000 0000",
  "customers.form.emailPlaceholder": "例如 customer@example.com",
  "customers.form.cancel": "取消",
  "customers.form.saving": "正在保存客户",
  "customers.form.save": "保存客户",
  "customers.form.create": "创建客户",
  "customers.validation.oneContactRequired": "姓名、电话和邮箱至少填写一项。",
  "customers.validation.nameTooLong": "客户姓名不能超过 {count} 个字符。",
  "customers.validation.phoneTooLong": "电话号码不能超过 {count} 个字符。",
  "customers.validation.emailTooLong": "邮箱不能超过 {count} 个字符。",
  "customers.validation.invalidEmail": "请输入有效的邮箱地址。",
  "customers.createdToast": "客户「{name}」已创建",
  "customers.savedToast": "客户「{name}」已保存",
  "customers.detail.fallbackTitle": "客户 360",
  "customers.detail.returnToCustomer": "返回客户",
  "customers.detail.returnToTicket": "返回工单",
  "customers.detail.backToList": "返回客户列表",
  "customers.detail.refreshing": "正在刷新客户 360",
  "customers.detail.description": "统一查看客户身份、联系资料，以及当前权限范围内可访问的服务记录。",
  "customers.detail.loading": "正在加载客户 360…",
  "customers.detail.serviceRecords": "客户服务记录",
  "customers.profile.identityLinked": "已关联可信业务身份",
  "customers.profile.identityNotLinked": "尚未关联可信业务身份",
  "customers.profile.edit": "编辑资料",
  "customers.profile.contact": "联系方式",
  "customers.profile.phone": "电话",
  "customers.profile.email": "邮箱",
  "customers.profile.businessId": "业务标识",
  "customers.profile.noBusinessId": "尚未绑定由可信业务系统验证的用户标识。",
  "customers.profile.extended": "扩展资料",
  "customers.profile.noExtendedTitle": "暂无扩展资料",
  "customers.profile.noExtendedDetail": "外部业务系统补充的只读信息会显示在这里。",
  "customers.profile.createdAt": "创建于 {date}",
  "customers.profile.updatedAt": "最近更新 {date}",
  "customers.service.loading": "正在加载客户服务记录…",
  "customers.service.hiddenTitle": "服务记录未展示",
  "customers.service.hiddenDetail": "你可以查看客户资料，但没有查看工单的权限。服务指标和工单历史不会被请求或展示。",
  "customers.service.errorTitle": "服务记录加载失败",
  "customers.service.errorDetail": "客户资料仍然可用；请重试加载当前权限范围内的工单数据。",
  "customers.service.retry": "重试",
  "customers.service.refreshing": "正在刷新服务记录",
  "customers.service.refreshingShort": "正在刷新",
  "customers.service.ticketPaginationLabel": "条工单",
  "customers.metrics.title": "服务概览",
  "customers.metrics.description": "当前权限范围内可见的关联工单服务指标。",
  "customers.metrics.total": "累计工单",
  "customers.metrics.totalDetail": "当前权限范围内可见的关联工单",
  "customers.metrics.active": "处理中",
  "customers.metrics.activeDetail": "尚未解决或关闭",
  "customers.metrics.resolved": "已解决",
  "customers.metrics.resolvedDetail": "已解决及已关闭",
  "customers.metrics.recent": "最近服务",
  "customers.metrics.noRecent": "暂无记录",
  "customers.metrics.recentDetail": "最近一次工单活动",
  "customers.tickets.title": "最近工单",
  "customers.tickets.description": "按最近更新时间展示与该客户关联的工单。",
  "customers.tickets.ticket": "工单",
  "customers.tickets.status": "状态",
  "customers.tickets.priority": "优先级",
  "customers.tickets.project": "项目",
  "customers.tickets.assignee": "跟进人",
  "customers.tickets.updatedAt": "最近更新",
  "customers.tickets.unspecifiedProject": "未指定项目",
  "customers.tickets.unassigned": "待分配",
  "customers.tickets.viewAll": "查看全部",
  "customers.tickets.empty": "该客户还没有关联工单"
}
